import { render, staticRenderFns } from "./EditCollectionModal.vue?vue&type=template&id=1c5a2444&lang=pug&"
import script from "./EditCollectionModal.vue?vue&type=script&lang=js&"
export * from "./EditCollectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports